export const environment = {
  CORE_URL: 'https://dev-hero.ikunnect.com/api/',
  STRIPE_CLIENT_TOKEN:
    'pk_test_51QH3UxLmtmaPxNqrWwTvjcQV6EBcTsGygwjM9TWj894k7FOQmwgaaYZj1DhwWjPfbeDZvwLSSrsm6jn7LPPz60ft00A0V4a7v7',
  LOG_LEVEL: 2,
  ENV: 'dev',
  ZAMMAD_CHAT_URL: 'https://spectrum.qa.helpdesk.ikunnect.com/',
  ZAMMAD_WEBSOCKET: `wss://spectrum.qa.helpdesk.ikunnect.com/ws`,
  WORD_PRESS: 'https://blog.ikunnect.com/wp-json/wp/v2/',
};
